import { Injectable } from "@angular/core";
import { Alarm } from "../models";
import { ModelMarkers } from "app/pages/components/leaflet-map/marker-model";

@Injectable()
export class MapUtilService {
    
    /**
     * Recebe lista de alarmes e converte para o formato Model Makers
     * @param alarmList Lista de Alarmes
     */
    public alarmToModelMakerList(alarmList : any) : ModelMarkers[] {
        let modelMakerList: ModelMarkers[] = [];


        alarmList.forEach((alarm : any) => {

            if(alarm.infractionData) {
                let mrkr: ModelMarkers = new ModelMarkers;
                mrkr.id = alarm.id;
                mrkr.name = alarm.infractionData.driver? alarm.infractionData.driver.driverFirstName : null;
                mrkr.category = this.convertInfractionCategoryType(alarm.infractionTypeId);
                mrkr.enabled = true;
                mrkr.latitude = parseFloat(alarm.latitude);
                mrkr.longitude = parseFloat(alarm.longitude);
    
                modelMakerList.push(mrkr);
            } else {
                let mrkr: ModelMarkers = new ModelMarkers;
                mrkr.id = alarm.id;
                mrkr.name = alarm.driver_firstname;
                mrkr.category = alarm.typeAlarm;
                mrkr.enabled = true;
                mrkr.latitude = alarm.latitude;
                mrkr.longitude = alarm.longitude;
    
                modelMakerList.push(mrkr);
            }
        })

        return modelMakerList;
    }

    convertInfractionCategoryType(infractionTypeId) {
        const SPEED_INFRACTION = 1
        const NO_SEATBELT_INFRACTION = 4
        const ABRUPT_BREAK_INFRACTION = 6
        const ABRUPT_SPEED_INFRACTION = 7
        const ABRUPT_CURVE_INFRACTION = 9
        const VIBRATION_INFRACTION = 10
        const DEVICE_REMOVED_INFRACTION = 11
        const DEVICE_NO_BATTERY_INFRACTION = 12
        const DEVICE_SLEEP_INFRACTION = 13
        if(infractionTypeId === SPEED_INFRACTION) return 3003
        if(infractionTypeId === NO_SEATBELT_INFRACTION) return 3004
        if(infractionTypeId === ABRUPT_BREAK_INFRACTION) return 3006
        if(infractionTypeId === ABRUPT_SPEED_INFRACTION) return 3007
        if(infractionTypeId === ABRUPT_CURVE_INFRACTION) return 3009
        if(infractionTypeId === VIBRATION_INFRACTION) return 3010
        if(infractionTypeId === DEVICE_REMOVED_INFRACTION) return 3011
        if(infractionTypeId === DEVICE_NO_BATTERY_INFRACTION) return 3012
        if(infractionTypeId === DEVICE_SLEEP_INFRACTION) return 3013
        
    }
}